import type { RouteRecordInfo } from 'vue-router'

import type { PaymentMethodCode as BuybackPaymentMethodCode } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher.types'

import { PaymentFlow } from './flows'

/**
 * Known paths of payment pages on the payment subdomain for each flow.
 */
export const PaymentRoutePaths: Record<PaymentFlow, RouteRecordInfo['path']> = {
  [PaymentFlow.CHECKOUT_CART]: 'checkout/cart',
  [PaymentFlow.BUYBACK_SELLER_UPDATE_PAYMENT_METHOD]:
    'seller/buyback/update-payment-method/:code',
} as const

/**
 * Helpers to build the path of a payment page based on the flow parameters.
 */
const PaymentRouteBuilders: Record<
  PaymentFlow,
  (params: PaymentRouteParams<PaymentFlow>) => string
> = {
  [PaymentFlow.CHECKOUT_CART]: () =>
    PaymentRoutePaths[PaymentFlow.CHECKOUT_CART],
  [PaymentFlow.BUYBACK_SELLER_UPDATE_PAYMENT_METHOD]: (params) =>
    PaymentRoutePaths[PaymentFlow.BUYBACK_SELLER_UPDATE_PAYMENT_METHOD].replace(
      ':code',
      params.code,
    ),
} as const

/**
 * Build the relativepath of a payment page based on the flow parameters.
 */
export const buildPaymentRoute = <Flow extends PaymentFlow>(
  flow: Flow,
  params: PaymentRouteParams<Flow>,
) => PaymentRouteBuilders[flow](params)

type PaymentFlowParamTypes = {
  [PaymentFlow.BUYBACK_SELLER_UPDATE_PAYMENT_METHOD]: {
    code: BuybackPaymentMethodCode
  }
}

/**
 * Type to help the autocomplete of the flow parameters based on the flow.
 */
export type PaymentRouteParams<Flow extends PaymentFlow> =
  Flow extends keyof PaymentFlowParamTypes ? PaymentFlowParamTypes[Flow] : never
